<template>
  <div class="home">
    <NavBar />
    <HumoHeader title="Concertagenda" lead="Wat speelt waar en wat moet je zien? HUMO verzamelt de beste concerten in Vlaanderen." />
    <ConcertGrid />
    <HumoFooter />
  </div>
</template>

<script>
import HumoFooter from '@/components/HumoFooter.vue'
import HumoHeader from '@/components/HumoHeader.vue'
import NavBar from '@/components/NavBar.vue'
import ConcertGrid from '@/components/ConcertGrid.vue'
import bootstrap from 'bootstrap/scss/bootstrap.scss'

export default {
  name: 'App',
  components: {
    ConcertGrid,
    NavBar,
    HumoHeader,
    HumoFooter
  }
}
</script>

<style lang="scss">
@import "assets/styles/style";
</style>
